import validate from "/apps/web/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_7877e1059fd6beb6dc82ce05aa3e1262/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45device_45global from "/apps/web/middleware/1.device.global.ts";
import manifest_45route_45rule from "/apps/web/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_7877e1059fd6beb6dc82ce05aa3e1262/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45device_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}